import React, { Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import { Text, OrbitControls, Stars, Float } from '@react-three/drei'
import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div style={{ height: '100vh', width: '100vw', background: '#000' }}>
      <Canvas camera={{ position: [0, 0, 10], fov: 50 }}>
        <Stars radius={100} depth={50} count={4000} factor={4} fade />
        <ambientLight intensity={0.3} />
        <directionalLight position={[5, 5, 5]} intensity={1} />

        <Suspense fallback={null}>
          <Float speed={2} rotationIntensity={1} floatIntensity={1.5}>
            <Text fontSize={2} color="#ff3366" anchorX="center" anchorY="middle" maxWidth={10}>
              404
            </Text>
          </Float>
        </Suspense>

        {/* Make this the default controls for this Canvas, but with rotation/pan/zoom disabled */}
        <OrbitControls
          makeDefault
          enableRotate={false}
          enableZoom={false}
          enablePan={false}
        />
      </Canvas>

      <div style={{ position: 'absolute', top: '70%', width: '100%', textAlign: 'center', color: 'white', fontFamily: 'sans-serif' }}>
        <h2>Oops! Page not found.</h2>
        <button
          style={{ padding: '10px 20px', fontSize: '16px', marginTop: '10px', borderRadius: '8px', border: 'none', background: '#ff3366', color: 'white', cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          Go Home
        </button>
      </div>
    </div>
  )
}